import { SharedState } from '@trello/shared-state';

export const appRenderState = new SharedState<'paint' | 'afterPaint'>('paint');
